import { CRUD_PERMISSIONS } from "../../enums/common/crud-permissions.enum.mjs";
/**
 * Role Class
 * implements IRole
 */
export class Role {
  // #region Properties (3)
  crud = CRUD_PERMISSIONS.UNKNOWN;
  hash_key = "";
  role_name = "";
  // #endregion Properties (3)
  // #region Public Static Methods (1)
  /**
   *
   * @param { IRole } role Returns an instance from an interface
   * @return { Role }
   */
  static createRole(iRole) {
    let roleClass = new Role();
    roleClass.role_name = iRole.role_name;
    roleClass.crud = iRole.crud;
    roleClass.hash_key = iRole.hash_key;
    return roleClass;
  }
  // #endregion Public Static Methods (1)
  // #region Public Methods (8)
  canCreate() {
    return CRUD_PERMISSIONS.CREATE === (this.crud & CRUD_PERMISSIONS.CREATE);
  }
  canDelete() {
    return CRUD_PERMISSIONS.DELETE === (this.crud & CRUD_PERMISSIONS.DELETE);
  }
  canExecute() {
    return CRUD_PERMISSIONS.EXECUTE === (this.crud & CRUD_PERMISSIONS.EXECUTE);
  }
  canMerwe() {
    return CRUD_PERMISSIONS.MERGE === (this.crud & CRUD_PERMISSIONS.MERGE);
  }
  canRead() {
    return CRUD_PERMISSIONS.READ === (this.crud & CRUD_PERMISSIONS.READ);
  }
  canUpdate() {
    return CRUD_PERMISSIONS.UPDATE === (this.crud & CRUD_PERMISSIONS.UPDATE);
  }
  checkPermission(crudPermission) {
    const result = crudPermission === (this.crud & crudPermission);
    if (!result) {
      console.debug("checkPermission", crudPermission);
      console.debug("checkPermission", this.crud);
    }
    return result;
  }
  hasPII() {
    return CRUD_PERMISSIONS.PII === (this.crud & CRUD_PERMISSIONS.PII);
  }
}